import { isValidUrl } from '~/utils';

export const isPaymentInfoResponseEpaymentsRedirect = (
  response?: string,
): boolean => {
  if (!response) {
    return false;
  }

  return (
    !!response &&
    response.includes('action=') &&
    response.includes('epayment.nets')
  );
};

export const formatRedirectUrl = (response?: string): string | null => {
  if (!response) {
    return null;
  }

  let cardPaymentRedirectUrl = response.split('action="')[1];
  cardPaymentRedirectUrl = cardPaymentRedirectUrl.split('"')[0];
  cardPaymentRedirectUrl = cardPaymentRedirectUrl.replaceAll('&amp;', '&');

  if (!isValidUrl(cardPaymentRedirectUrl)) {
    return null;
  }

  return cardPaymentRedirectUrl;
};
